import {unwrapResult} from '@reduxjs/toolkit';
import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useHistory} from 'react-router-dom';
import {requestOK} from 'redux-thunk-kit';
import {Col, UiButton, UiQuestionnaireLayout, UiText} from '~/components/elements';
import {PAGE_URLS} from '~/constants';
import {
  ELEVATE_LINK,
  WEIGHT_LOSS_RENEWAL_KEYS,
  WEIGHT_LOSS_RENEWAL_QUESTIONNAIRES,
} from '~/constants/medical-questionnaires';
import {useNotification, useRequestState} from '~/hooks';
import {setMedicalUUID, setQuestionnaireAnswer, setQuestionnaireMeta} from '~/redux/questionnaires/slice';
import {getMdqStatus, submitOrLogMdq} from '~/redux/questionnaires/thunk';
import {RootState} from '~/redux/root-reducer';
import {AppDispatch} from '~/redux/root-store';
import {redirectInIframe} from '~/utils/helpers';

interface Props {}

const MDQRenewalQuestionnaire5Screen = ({}: Props) => {
  const dispatch: AppDispatch = useDispatch();
  const history = useHistory();
  const {addMessage} = useNotification(dispatch);
  const mdq = useSelector((state: RootState) => state.questionnaires);
  const [redirectLoading, setRedirectLoading] = useState(false);
  const {loading: checkStatusLoading} = useRequestState(getMdqStatus);
  const {loading: submitLoading} = useRequestState(submitOrLogMdq);
  const {methodKey, medicalUUID, answerOrder, questionnaireMeta} = mdq;
  //   const medicalQuestionnaire = useSelector((state: RootState) => state.questionnaires.medicalQuestionnaire);
  //   const {wpAuthUser} = medicalQuestionnaire;

  //   const questionnaires = medicalQuestionnaire?.questionnaires;
  const questionnaire = WEIGHT_LOSS_RENEWAL_QUESTIONNAIRES.find(i => i.key === WEIGHT_LOSS_RENEWAL_KEYS.WHATS_NEXT);

  const currentAnswer = useSelector(
    (state: RootState) => state.questionnaires?.collectedData[WEIGHT_LOSS_RENEWAL_KEYS.WHATS_NEXT]?.data,
  );

  const collectedData = mdq.collectedData;
  const medications = questionnaireMeta?.medication || [];

  const onClickSubmit = async () => {
    const answerData = {
      key: WEIGHT_LOSS_RENEWAL_KEYS.WHATS_NEXT,
      index: questionnaire?.index || '',
      data: {},
      order: answerOrder + 1,
    };

    const statusCheckRes = await dispatch(getMdqStatus({id: medicalUUID || ''}));

    if (requestOK(statusCheckRes, getMdqStatus)) {
      const statusResult = unwrapResult(statusCheckRes);
      if (statusResult?.status === 'submitted' || statusResult?.status === 'expired') {
        addMessage('Medical Questionnaire already submitted or expired', 'error');
        return;
      }
      // if (statusResult?.meta) {
      //   dispatch(setQuestionnaireMeta({meta: statusResult.meta}));
      // }
    }

    dispatch(setQuestionnaireAnswer(answerData));
    const res = await dispatch(
      submitOrLogMdq({
        data: {
          uid: medicalUUID,
          methodKey: methodKey.toLowerCase(),
          status: 'submitted',
          data: {
            ...collectedData,
            [WEIGHT_LOSS_RENEWAL_KEYS.WHATS_NEXT]: answerData,
          },
        },
      }),
    );

    if (requestOK(res, submitOrLogMdq)) {
      const result = unwrapResult(res);
      if (result?.getCheckoutUrl) {
        setRedirectLoading(true);
        redirectInIframe(result.getCheckoutUrl);
      }
    }

    if (res.payload?.errMsg === 'Medical Form invalid') {
      dispatch(setMedicalUUID({uid: null}));
      history.replace(PAGE_URLS.MDQ_RENEWAL_HOME + window.location.search);
    }
  };

  return (
    <UiQuestionnaireLayout
      backIcon
      actions={questionnaire?.actions}
      checkoutStep={questionnaire?.checkoutStep}
      pageTitle={questionnaire?.title}
    >
      <Col textAlign="center" mt={20} px={2}>
        <UiText fontSize="2xl" fontWeight="bold" mb={6}>
          {questionnaire?.questions?.default}
        </UiText>
        <Col w="92%" alignItems="center" alignSelf="center" mb={4}>
          {questionnaire?.descriptions?.default.map((description, index) => (
            <UiText key={index} fontSize="sm" fontWeight="400" color="liteOuter" mb={2}>
              {description}
            </UiText>
          ))}
          {medications.map((medication, index) => (
            <UiText key={index} fontSize="sm" fontWeight="400" color="liteOuter" mb={2}>
              {medication.name}, Qty: {medication.qty}
            </UiText>
          ))}
        </Col>
        <Col alignItems="center" justifyContent="center" w="100%">
          <UiButton
            isLoading={redirectLoading || checkStatusLoading || submitLoading}
            onClick={onClickSubmit}
            w="55%"
            variant="primary"
          >
            Continue
          </UiButton>
        </Col>
      </Col>
    </UiQuestionnaireLayout>
  );
};

export default MDQRenewalQuestionnaire5Screen;
